import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import KwilDB from "kwildb"
import { useEffect, useRef, useState } from "react"
import AddFundsButton from "./AddFundsButton";

export default function FundingPool({ pool, totalFunds, setTotalFunds, setTotalData }) {
    const [balance, setBalance] = useState(0)
    const [loading, setLoading] = useState(true)
    const [status, setStatus] = useState(null)
    const [errMsg, setErrMsg] = useState("")
    const [adding, setAdding] = useState(false)

    const multiplier = useRef(
        pool.token === "USDC" ? 1000000 : 1000000000000000000
    )

    useEffect(() => {
        setTimeout(async function () {
            const result = await KwilDB.pools.getPool(
                pool.pool_name,
                pool.blockchain,
                pool.token
            )
            setBalance(result.pool)
            setLoading(false)
        })
    }, [])
    
    return(
       <div className="pool-view">
            <p style={{ color: "#fff", fontSize: "20px", fontWeight: "bold" }}>
                {pool.pool_name}
            </p>
            <p style={{ color: "#fff", margin: "6px auto 6px 0px" }}>
                <span>Chain: </span>
                {pool.blockchain}
            </p>
            <div style={{ display: "flex" }}>
                <p>
                    <span>Token: </span>
                    {pool.token}
                </p>
                <p style={{ margin: "auto" }}>
                    <span style={{ margin: "auto" }}>Balance: </span>
                    {loading ? "Loading..." :  balance / multiplier.current} USD
                </p>
            </div>
            <p style={{ color: "#fff", margin: "6px auto 6px 0px", wordBreak: "break-word" }}>
                <span>Validator: </span>
                {pool.validator}
            </p>
            <AddFundsButton
                setStatus={setStatus}
                setErrMsg={setErrMsg}
                pool={pool}
                totalFunds={totalFunds}
                setTotalFunds={setTotalFunds}
                setTotalData={setTotalData}
                setAdding={setAdding}
                multiplier={multiplier}
            />
            <Backdrop sx={{ display: "flex", flexDirection: "column" }} open={adding}>
                <CircularProgress sx={{ color: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)" }} />
                <p style={{ margin: "20px auto", color: "#fff", fontFamily: "Averta" }}>
                Please wait, this may take several minutes...
                </p>
            </Backdrop>
            <Snackbar
                sx={{ margin: "0px auto" }}
                open={status === "error"}
                autoHideDuration={6000}
                onClose={() => setStatus(null)}
            >
                <Alert
                    variant="filled"
                    severity="error"
                    sx={{ width: "100%"}}
                >
                    {errMsg}
                </Alert>
            </Snackbar>
            <Snackbar
                sx={{ margin: "0px auto" }}
                open={status === "fail"}
                autoHideDuration={6000}
                onClose={() => setStatus(null)}
            >
                <Alert
                    variant="filled"
                    severity="error"
                    sx={{ width: "100%"}}
                >
                    Funds not added. Reason: {errMsg}
                </Alert>
            </Snackbar>
            <Snackbar
                sx={{ margin: "0px auto" }}
                open={status === "success"}
                autoHideDuration={4000}
                onClose={() => setStatus(null)}
            >
                <Alert
                variant="filled"
                onClose={() => setStatus(null)}
                severity="success"
                sx={{ width: "100%" }}
                >
                Funds added succesfully to the funding pool!
                </Alert>
            </Snackbar>
        </div>
    )
}